import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { PinnedHotelViewModel } from 'models';
import { UitkCardFeaturedHeader } from 'uitk-react-cards';
import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

export interface TitleHeadingProps {
  headingInfo: PinnedHotelViewModel;
}

export const TitleHeading: React.FunctionComponent<TitleHeadingProps> = ({ headingInfo }) => {
  const headingIcon = (
    <span className="all-r-margin-three">
      <UitkIcon name={headingInfo.icon} size={UitkIconSize.EXTRA_SMALL} />
    </span>
  );

  const headingText = <span className="uitk-type-300 uitk-type-medium">{headingInfo.heading}</span>;

  return (
    <AbacusExperiment name="pwa_hsr_pinned_property">
      <AbacusControl>
        <div className="uitk-cell uitk-card-separator-bottom">
          <div className="all-y-padding-two all-x-padding-three title__caption">
            {headingInfo.icon && headingIcon}
            {headingText}
          </div>
        </div>
      </AbacusControl>
      <AbacusVariant bucket={1}>
        <div className="uitk-cell">
          <UitkCardFeaturedHeader>
            {headingInfo.icon && headingIcon}
            {headingText}
          </UitkCardFeaturedHeader>
        </div>
      </AbacusVariant>
    </AbacusExperiment>
  );
};
